import { render, staticRenderFns } from "./StepResidentGBR.vue?vue&type=template&id=63141c7e&"
import script from "./StepResidentGBR.vue?vue&type=script&lang=js&"
export * from "./StepResidentGBR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports